let parameters = {
    content: {
        label: 'Content',
        source: 'parameters.never',
        items: [],
        types: [],
        item: {data: [], headers: []},
        class: 'xs12 sm12 d-flex',
        type: 'hidden',
        value: '',
        display: false,
        wait: false
    },
    buttonMenu: {
        label: 'Button Menu',
        class: 'xs12 sm12',
        type: 'textarea',
        value: ""
    }
};

export default parameters;
